import { ValidateButton } from "#components/atoms/ValidateButton/ValidateButton";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useValidateCosting } from "#modules/quoteRequestLines/views/useValidateCosting";
import { JobStatusSchema, PartTypeSchema } from "shared";

type Props = {
  line: QuoteRequestLineDto;
};

export const ValidatedCell = ({ line }: Props) => {
  const { validateCosting } = useValidateCosting(line.quoteRequestId);
  const isConsumable = line.part.type === PartTypeSchema.enum.CONSUMABLE;
  const hasNoCost = line.predictionStatus !== JobStatusSchema.enum.PROCESSED;

  return (
    <ValidateButton
      checked={line.isReliable}
      disabled={isConsumable || hasNoCost}
      onChange={() => validateCosting(line.id)}
    />
  );
};
